"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.olMap = void 0;
var strongly_typed_events_1 = require("strongly-typed-events");
var IMapEvents_1 = require("./events/IMapEvents");
var VectorLayerStrategy_1 = require("../layers/vector/VectorLayerStrategy");
var ZoomToDataBounds_1 = require("../layers/vector/ZoomToDataBounds");
var olProj = require("ol/proj");
var olExtent = require("ol/extent");
var View_1 = require("ol/View");
var olMap = /** @class */ (function () {
    function olMap(olMap, _options, _mapStore, _logger, _boundsLoaderBehaviour, _contextMenu, _filters, _mappingTextPack) {
        var _this = this;
        this.olMap = olMap;
        this._options = _options;
        this._mapStore = _mapStore;
        this._logger = _logger;
        this._boundsLoaderBehaviour = _boundsLoaderBehaviour;
        this._contextMenu = _contextMenu;
        this._filters = _filters;
        this._mappingTextPack = _mappingTextPack;
        //events
        this._onZoomChanged = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onLayerLoaded = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onVectorLayerGroupLoaded = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onWmsLayerGroupLoaded = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onLayerLoading = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onLayerVisibilityChanged = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onLayerAction = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onBaseLayerVisibilityChanged = new strongly_typed_events_1.SimpleEventDispatcher();
        this.init = function () {
            var self = _this;
            for (var _i = 0, _a = self.options.layerGroupCollection.vectorLayerGroups; _i < _a.length; _i++) {
                var vectorLayerGroup = _a[_i];
                vectorLayerGroup.onLayerGroupLoaded.subscribe(self.handleVectorLayerGroupLoaded);
            }
            for (var _b = 0, _c = self.options.layerGroupCollection.wmsLayerGroups; _b < _c.length; _b++) {
                var wmsLayerGroup = _c[_b];
                wmsLayerGroup.onLayerGroupLoaded.subscribe(self.handleWmsLayerGroupLoaded);
            }
        };
        this.raiseOnLayerAction = function (args) {
            if (args.action === IMapEvents_1.LayerActionEvent.zoomToDataBounds) {
                var bounds = args.layerGroup.getBoundsForLoadedLayers();
                if (bounds !== null && !olExtent.isEmpty(bounds)) {
                    _this.olMap.getView().fit(bounds, { duration: 1000, nearest: false });
                }
            }
            _this._onLayerAction.dispatch(args);
        };
        this.raiseOnLayerVisibilityChanged = function (args) {
            _this._onLayerVisibilityChanged.dispatch(args);
        };
        this.raiseOnBaseLayerVisibilityChanged = function (args) {
            _this._onBaseLayerVisibilityChanged.dispatch(args);
        };
        this.addWmsLayerHandler = function (wmsLayer) {
            wmsLayer.onLayerLoading.subscribe(_this.onWmsLayerLoading);
            wmsLayer.onLayerLoaded.subscribe(_this.onWmsLayerLoaded);
        };
        this.addVectorLayerHandler = function (vectorLayer) {
            vectorLayer.onLayerLoading.subscribe(_this.onVectorLayerLoading);
            vectorLayer.onLayerLoaded.subscribe(_this.onVectorLayerLoaded);
        };
        this.getReprojectedMapExtent = function (toProjection) {
            var extents = _this.olMap.getView().calculateExtent(_this.olMap.getSize());
            var mapProj = _this.olMap.getView().getProjection().getCode();
            var bl = olProj.transform([extents[0], extents[1]], mapProj, toProjection);
            var tr = olProj.transform([extents[2], extents[3]], mapProj, toProjection);
            return { minx: bl[0], miny: bl[1], maxx: tr[0], maxy: tr[1] };
        };
        this.getZoom = function () {
            return _this.olMap.getView().getZoom();
        };
        this.getDisplayProjection = function () {
            return _this.olMap.getView().getProjection();
        };
        this.addOnMapZoomHandler = function () {
            var self = _this;
            var addZoomHandler = function () {
                self.olMap.getView().on("change:resolution", function (e) {
                    var zoom = e.target.getZoom();
                    var extent = self.getReprojectedMapExtent(self.options.dataProjection);
                    var currentExtentUsingDataProjection = [extent.minx, extent.miny, extent.maxx, extent.maxy];
                    //this event seems to be firing multiple times until an integer zoomlevel is reached
                    //we therefore need to test for when zoom is a whole int before we do anything
                    if (zoom % 1 === 0) {
                        console.log("zoom= " + e.target.getZoom());
                        //set the layer visibilities first
                        for (var _i = 0, _a = self.options.layerGroupCollection.layerGroupCollections; _i < _a.length; _i++) {
                            var grpCol = _a[_i];
                            for (var _b = 0, _c = grpCol.layerGroups; _b < _c.length; _b++) {
                                var grp = _c[_b];
                                if (grp.isVisible(self._mapStore)) {
                                    for (var _d = 0, _e = grp.layers; _d < _e.length; _d++) {
                                        var lyr = _e[_d];
                                        lyr.setVisibility(zoom, self._mapStore);
                                        self._logger.log("Layer " + grp.ref + " visible=" + ((lyr.visible) ? "yes" : "no"));
                                    }
                                }
                            }
                        }
                        //see what layer sources need clearing
                        for (var _f = 0, _g = self.options.layerGroupCollection.vectorLayerGroups; _f < _g.length; _f++) {
                            var grp = _g[_f];
                            if (grp.isVisible(self._mapStore)) {
                                for (var _h = 0, _j = grp.layers; _h < _j.length; _h++) {
                                    var layer = _j[_h];
                                    if (layer.visible === true && self.isUsingBboxStrategy(layer) === true) {
                                        if (self._boundsLoaderBehaviour.reloadLayer(currentExtentUsingDataProjection, layer, zoom, grp.maxFeatureCount)) {
                                            //clear the source to reload the layer
                                            self._logger.log("Clearing source for " + grp.ref + " @zoom " + zoom);
                                            layer.clearSource();
                                        }
                                    }
                                }
                            }
                        }
                        //do this last so other events follow in order after the layer vis has been set
                        self._onZoomChanged.dispatch({ zoomLevel: e.target.getZoom() });
                    }
                });
            };
            //handle view change too (record map - a new view is created with restricted bounds on ajax success), 
            //if the view is changed we lose the handler            
            self.olMap.on("change:view", function (e) {
                setTimeout(function () { addZoomHandler(); }, 100);
            });
            addZoomHandler();
        };
        this.isUsingBboxStrategy = function (layer) {
            if (layer.group.strategy === VectorLayerStrategy_1.VectorLayerStrategy.Bbox) {
                return true;
            }
            if (layer.group.strategy === VectorLayerStrategy_1.VectorLayerStrategy.OgcFilterBbox
                && ((!layer.group.useBbox_WithFilter && !_this.filters.hasFilter(layer.group.filterOptions)) || layer.group.useBbox_WithFilter)) {
                _this._logger.log("Using bbox strategy for layer: " + layer.group.displayName + ":" + layer.layerName);
                return true;
            }
            return false;
        };
        this.handleWmsLayerGroupLoaded = function (args) {
            _this._onWmsLayerGroupLoaded.dispatch(args);
        };
        this.onWmsLayerLoading = function (args) {
            var self = _this;
            self._loadingCount += 1;
            $("#mapLoader").show();
        };
        this.onWmsLayerLoaded = function (args) {
            var self = _this;
            self._loadingCount -= 1;
            if (self._loadingCount === 0) {
                $("#mapLoader").hide("slow");
            }
        };
        this.onVectorLayerLoading = function (args) {
            var self = _this;
            self._loadingCount += 1;
            $("#mapLoader").show();
            self._onLayerLoading.dispatch({
                layer: args.layer
            });
        };
        this.handleVectorLayerGroupLoaded = function (args) {
            var self = _this;
            if (args.dataBounds) {
                var bufferInMetres = olExtent.getWidth(args.dataBounds) * 0.15;
                //check to see if we should zoom to the bounds of this layer
                if (self.shouldZoomToBounds(args.layerGroup) === true && !olExtent.isEmpty(args.dataBounds)) {
                    //check to see if we need to limit the map extent
                    if (args.layerGroup.restrictMapExtentToDataBounds) {
                        self.olMap.setView(new View_1.default({
                            extent: olExtent.buffer(args.dataBounds, bufferInMetres),
                            constrainOnlyCenter: true,
                            minZoom: self._options.minZoom,
                            maxZoom: self._options.maxZoom,
                            projection: self.getDisplayProjection(),
                            constrainResolution: true // force zooming to a integer zoom
                        }));
                    }
                    try {
                        //we only want to zoom to bounds once per filter and not on subsequent pan/zoom events
                        args.layerGroup.hasZoomedToBounds = true;
                        var exBounds = olExtent.buffer(args.dataBounds, bufferInMetres);
                        self.olMap.getView().fit(exBounds, { maxZoom: self._options.maxZoomToBounds, nearest: self._options.zoomToNearestBounds });
                    }
                    catch (_a) {
                        _this._logger.error("Failed to zoom to bounds, missing geom?");
                    }
                }
            }
            _this._onVectorLayerGroupLoaded.dispatch(args);
        };
        this.onVectorLayerLoaded = function (args) {
            var self = _this;
            self._loadingCount -= 1;
            if (self._loadingCount === 0) {
                $("#mapLoader").hide("slow");
            }
            self._onLayerLoaded.dispatch({
                layer: args.layer,
                maxFeatures: args.maxFeatureCountReached,
                dataLoaded: args.dataLoaded
            });
        };
        this.shouldZoomToBounds = function (layerGroup) {
            if (layerGroup.hasZoomedToBounds === false) {
                if (layerGroup.zoomToDataBounds === ZoomToDataBounds_1.ZoomToDataBounds.Always) {
                    return true;
                }
                if (layerGroup.zoomToDataBounds === ZoomToDataBounds_1.ZoomToDataBounds.OnlyWithFilter) {
                    return _this.filters.hasFilter(layerGroup.filterOptions);
                }
            }
            return false;
        };
        this.reLoad = function () {
            for (var _i = 0, _a = _this.options.layerGroupCollection.layerGroupCollections; _i < _a.length; _i++) {
                var grpCol = _a[_i];
                grpCol.layerGroups.forEach(function (layerGroup) {
                    layerGroup.reLoadLayers();
                });
            }
        };
        this._baseLayers = [];
        this._loadingCount = 0;
        this.init();
    }
    Object.defineProperty(olMap.prototype, "onZoomChanged", {
        get: function () {
            return this._onZoomChanged.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onLayerLoaded", {
        get: function () {
            return this._onLayerLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onVectorLayerGroupLoaded", {
        get: function () {
            return this._onVectorLayerGroupLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onWmsLayerGroupLoaded", {
        get: function () {
            return this._onWmsLayerGroupLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onLayerLoading", {
        get: function () {
            return this._onLayerLoading.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onLayerVisibilityChanged", {
        get: function () {
            return this._onLayerVisibilityChanged.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onLayerAction", {
        get: function () {
            return this._onLayerAction.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "onBaseLayerVisibilityChanged", {
        get: function () {
            return this._onBaseLayerVisibilityChanged.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    olMap.prototype.addWmsLayer = function (wmsLayer) {
        this.addWmsLayerHandler(wmsLayer);
        this.olMap.addLayer(wmsLayer.olWmsLayer);
    };
    olMap.prototype.addVectorLayer = function (vectorLayer) {
        this.addVectorLayerHandler(vectorLayer);
        this.olMap.addLayer(vectorLayer.olVectorLayer);
    };
    Object.defineProperty(olMap.prototype, "contextMenu", {
        get: function () {
            return this._contextMenu;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "filters", {
        get: function () {
            return this._filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "mapStore", {
        get: function () {
            return this._mapStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(olMap.prototype, "baseLayers", {
        get: function () {
            return this._baseLayers;
        },
        enumerable: false,
        configurable: true
    });
    return olMap;
}());
exports.olMap = olMap;
//# sourceMappingURL=Map.js.map